import { useRouter } from 'next/router';

import { waitForRouterReady } from './waitForRouterReady';

interface Options {
  suspense?: boolean;
}

export function useNextRouter(options: Options = { suspense: true }) {
  const router = useRouter();

  if (options.suspense && !router.isReady) {
    throw waitForRouterReady();
  }

  return router;
}
